// extracted by mini-css-extract-plugin
module.exports = {"avatar":"cd01fbf7b5--avatar--ceW9Q","clickable":"cd01fbf7b5--clickable--jjxbB","company":"cd01fbf7b5--company--MXKHY"};